<template>
  <li class="bookItem clearfix" @click="toBookInfo(item)">
    <img class="bookImg l" width="120" height="160" :src="imgPath+item.image"
         :onerror="imgError" :alt="item.bookName"/>
    <div class="bookInfo" v-if="recond">
    <h3 class=""  :style="recond? 'fontColor':'ellip '">{{item.bookName}}</h3>
   <div class="bookAuthor ellip bookAuthorStyle">作者：{{item.author&&item.author!=' '?item.author : '暂无数据'}}</div>
   <div class="imgbox">
       <img src="../assets/images/recommend.png"  alt=""  style="float:left" >
      <div class="fontstyle">{{item.recommendReason}}</div>
   </div>
        
    </div>
   <div class="bookInfo" v-else >
      <h3 class="ellip">{{item.bookName}}</h3>
      <div class="bookAuthor ellip">作者：{{item.author&&item.author!=' '?item.author : '暂无数据'}}</div>
      <div class="bookAuthor ellip">出版社：{{item.publisher&&item.publisher != ' '?item.publisher : '暂无数据'}}</div>
      <div class="bookAuthor ellip">出版年：{{item.publishDate&&item.publishDate != ' '?item.publishDate.substring(0,4) : '暂无数据'}}</div>
      <div class="bookAuthor ellip">ISBN：{{item.isbn&&item.isbn!=' '?item.isbn : '暂无数据'}}</div>
    </div>
  </li>
</template>

<script>
  import {store} from '../store/store';
  import {imgPath} from "../common/config";

  export default {
    name: 'book',
    props: ['item','recond'],
    data() {
      return {
        imgError: store.imgError,
        hallCode: '',
        imgPath:imgPath
      }
    },
    mounted() {
      this.hallCode = this.$route.query.hallCode || this.$route.query.libCode || ''
    },
    methods: {
      toBookInfo(item) {
        if (this.$route.params.type == 1) {
          var data={isbn: item.isbn, hallCode: this.hallCode};
          var libCode = this.$route.query.libCode || '';
          if(libCode!=""){
              data={isbn: item.isbn, libCode: libCode};
          }
          this.$router.push({path: '/bookcontent', query: data});
        } else if (this.$route.params.type == 2) {
          this.$router.push({path: '/ebookinfo', query: {id: item.id, libCode: this.hallCode}});
        }else {
            this.toInfo(item);
        }
      },
      toInfo(item){
        if (this.$route.query.type == 1) {
            var data={isbn: item.isbn, hallCode: this.hallCode};
            var libCode = this.$route.query.libCode || '';
            if(libCode!=""){
                data={isbn: item.isbn, libCode: libCode};
            }
            this.$router.push({path: '/bookcontent', query: data});
        } else if (this.$route.query.type == 2) {
          this.$router.push({path: '/ebookinfo', query: {id: item.id, hallCode: this.hallCode}});
        }
      }
    }
  }
</script>

<style lang="sass" scoped>
  .bookItem
    position: relative
    width: 282px
    margin-bottom: 60px
    cursor: pointer

  .bookItem:hover img
    opacity: 0.8
  .bookItem h3
   color: $themecolor1
    font-size: 16px

  .bookItem:hover h3
    color: $themecolor1
    text-decoration: underline

  .web2
    .bookItem
      &:hover
        h3
          color: $themecolor2

  .bookImg
    margin-right: 12px

  .bookInfo
    margin: 0 auto
    overflow: hidden

  .bookInfo h3
    margin:
    bottom: 10px
    font-size: 16px
    line-height: 18px
    font-weight: normal
    color: #333
   

  .bookAuthor
    font-size: 14px
    line-height: 36px
    color: #999
    .bookAuthorStyle
     width: 84px
     
     
     
   


  /*//电子书logo*/
  .ebookLogo
    position: absolute
    top: 0
    left: 0
    width: 55px
    height: 48px
    background: url("../assets/images/ebookjb.png") no-repeat
    z-index: 99
  .imgbox
   width: 152px
   height: 76px
   .fontstyle
     float:left
     font-size: 12px
     color:#666666
     line-height: 19px
     word-break: break-all;
     text-overflow: ellipsis;
     overflow: hidden;
     display: -webkit-box;
     -webkit-line-clamp: 4;
     -webkit-box-orient: vertical;
     text-indent: 5px
   .fontColor
     color:#CB7629 !important
 
     
    

     


    


</style>
